import React from 'react'
import { useQnaHook } from '../useQnaHook'
import { Button, TextField } from '@mui/material';

export default function AddQna() {
    const {
        qnaToAddTitle,
        setQnaToAddTitle,
        qnaToAddDesc,
        setQnaToAddDesc,
        addNewQna,
    } = useQnaHook();
    return (
        <div className='flex flex-col items-center'>
            <p className='text-2xl font-bold mb-4'>Add Qna</p>
            <hr className='w-1/2 mb-4' />
            <div className='flex flex-col items-center w-[450px]'>
                <p className='text-lg mb-4 text-center self-start my-4'>QnA Title</p>
                <input
                    type='text'
                    placeholder='Title'
                    value={qnaToAddTitle}
                    onChange={(e) => setQnaToAddTitle(e.target.value)}
                    className='border-2 border-gray-300 p-2 w-[450px] mb-4'
                />
                <p className='text-lg mb-4 text-center self-start my-4'>QnA Question</p>
                <TextField
                    label='Qna Question'
                    variant='filled'
                    sx={{
                        width: '450px',
                        marginBottom: '16px',
                        marginTop: '16px',
                        '& .MuiInputBase-root': {
                            minHeight: '250px',
                            height: 'auto',
                        },
                    }}
                    multiline
                    type="text"
                    placeholder='Question'
                    value={qnaToAddDesc}
                    onChange={(e) => setQnaToAddDesc(e.target.value)}
                />
                <Button
                    variant='contained'
                    onClick={addNewQna}
                    sx={{ marginTop: '2rem', marginBottom: '2rem' }}
                    disabled={qnaToAddTitle === '' || qnaToAddDesc === ''}
                    className='bg-blue-500 text-white p-2 w-1/2'
                >
                    Add Qna
                </Button>
            </div>
        </div>
    )
}
